export default {"src":"/_next/static/media/casino-lobby.28b0171c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};